
import { createBrowserRouter } from "react-router-dom";
import LoginPage from "../pages/Auth/LoginPage";
import PrivateRoute from "./PrivateRoute";
import Dashboard from "../pages/Dashboard";
import MainLayout from "../layouts/MainLayout";
import Requests from "../pages/Requests";
import CreateRequest from "../pages/Requests/CreateRequest";
import Users from "../pages/Users";
import CreateUser from "../pages/Users/CreateUser";
import Companies from "../pages/Companies";
import CreateCompanies from "../pages/Companies/CreateCompanies";
import LogoutPage from "../pages/Auth/LogoutPage";
import Employees from "../pages/Employees";
import CreateEmployee from "../pages/Employees/CreateEmployee";
import UpdateCompanies from "../pages/Companies/UpdateCompanies";
import UpdateUser from "../pages/Users/UpdateUser";
import UpdateEmployee from "../pages/Employees/UpdateEmployee";
import Labs from "../pages/Labs";
import YibfList from "../pages/Companies/YibfList";
import ResetPassword from "../pages/Users/ResetPassword";
import Cars from "../pages/Cars";
import CreateCar from "../pages/Cars/CreateCar";
import UpdateCar from "../pages/Cars/UpdateCar";
import MapTracker from "../pages/MapTracker";
import Holidays from "../pages/Holidays";
import CreateHoliday from "../pages/Holidays/CreateHoliday";
import UpdateHoliday from "../pages/Holidays/UpdateHoliday";

const routes = createBrowserRouter([
    {
        path: "/",
        element: <LoginPage />,
        children: [
            {
                path: "/login",
                element: <LoginPage />
            }
        ]
    },
    {
        path: "/logout",
        element: <LogoutPage />
    },
    {
        path: "/",
        element: <PrivateRoute component={MainLayout} />,
        children: [
            {
                path: "/dashboard",
                element: <Dashboard />
            },
            {
                path: "/requests",
                element: <Requests />
            },
            {
                path: "/requests/create",
                element: <CreateRequest />
            },
            {
                path: "/users",
                element: <Users />
            },
            {
                path: "/users/create",
                element: <CreateUser />
            },
            {
                path: "/users/edit/:usernameParams",
                element: <UpdateUser />
            },
            {
                path: "/users/reset-password/:usernameParams",
                element: <ResetPassword />
            },
            {
                path: "/companies/:type",
                element: <Companies />
            },
            {
                path: "/companies/create/:type",
                element: <CreateCompanies />
            },
            {
                path: "/companies/edit/:companyID",
                element: <UpdateCompanies />
            },
            {
                path: "/companies/yibf/:companyID",
                element: <YibfList />
            },
            {
                path: "/employees",
                element: <Employees />
            },
            {
                path: "/employees/create",
                element: <CreateEmployee />
            },
            {
                path: "/employees/edit/:employeeID",
                element: <UpdateEmployee />
            },
            {
                path: "/labs",
                element: <Labs />
            },
            {
                path: "/cars",
                element: <Cars />
            },
            {
                path: "/cars/create",
                element: <CreateCar />
            },
            {
                path: "cars/edit",
                element: <UpdateCar />
            },
            {
                path: "/map-tracker",
                element: <MapTracker />
            },
            {
                path: "/holidays",
                element: <Holidays />
            },
            {
                path: "/holidays/create",
                element: <CreateHoliday />
            },
            {
                path: "/holidays/update",
                element: <UpdateHoliday />
            }
        ]
    }
]
);

export default routes;
